import "core-js/modules/es.promise.js";
import { ENV_ANDROID, ENV_IOS } from '../../const';
import { env } from '../../getNativeInfo';
import { prepareApi, uniCall } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 关闭（退出）当前页面所在的 Web View
 */
export function exit() {
  return new Promise(function (resolve) {
    if (env === ENV_IOS || env === ENV_ANDROID) {
      uniCall({
        api: 'exit'
      });
      resolve();
    } else {
      history.back();
    }
  });
}